export default __webpack_public_path__ + "static/media/welcomeLogoActive.ecdc19f8.svg";